import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { refreshPage, toastStyle } from "../../Helpers/Utils/Common";
import ReactLoading from "react-loading";
import { Input, Button, Select, Row, Col, Space } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import briqueLogo from "../../Assets/Images/dreamnest_with_header.png";
import dreamnestlogo from "../../Assets/Images/dreamnest_logo_green.png";
import ettasLogo from "../../Assets/Images/ettasLogo.png";
import "../../cssFiles/LoginAdmin.css";
import { loginUser } from "../../Helpers/apiCalls/authApi";
import { UseGetRequest } from "../../Helpers/hooks/GetRequests";

const buildOwner = "dreamnest"; // has to be static for the build
const systemLogo = buildOwner === "dreamnest" ? briqueLogo : ettasLogo;
// const {Option} = Select;

export default function LoginAdmin() {
  // const { terminal } = useParams();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [userOptions, setUserOptions] = useState([]);
  const [disableClick, setDisableClick] = useState(false);
  const adminPages = [
    "CLI",
    "MEN",
    "CAT",
    "DIS",
    "USR",
    "RCR",
    "CTR",
    "EJO",
    "SAL",
    "PMR",
    "ITH",
    "SCS",
    "PWD",
    "ODS",
    "CCR",
    "CSC",
    "ADT",
    "XRE",
    "FNR",
    "RIS",
    "ORP",
    "ADP",
    "ACC",
  ];
  const cashierPages = [
    "CTR",
    "SAL",
    "PMR",
    "ITH",
    "SCS",
    "PWD",
    "ODS",
    "CCR",
    "CSC",
    "XRE",
    "RIS",
    "ORP",
    "ADP",
    "ACC",
  ];
  const staffPages = ["ORP", "ADP"];

  let navigate = useNavigate();

  async function submit(restoType) {
    setDisableClick(true);
    const response = await loginUser(username, password, restoType);
    if (response.data) {
      const result = response.data;
      if (result.role_id === "1" || result.role_id === "9") {
        //if manager or owner
        localStorage.setItem("permissions", JSON.stringify(adminPages));
      } else if (result.role_id === "7") {
        localStorage.setItem(
          "permissions",
          JSON.stringify([...adminPages, "ZRE"])
        );
      } else if (result.role_id === "2") {
        // if cashier
        localStorage.setItem("permissions", JSON.stringify(cashierPages));
      } else if (result.role_id === "8") {
        // if staff
        localStorage.setItem("permissions", JSON.stringify(staffPages));
      } else {
        localStorage.setItem("permissions", JSON.stringify([]));
      }
      localStorage.setItem("resto_login", JSON.stringify(restoType));
      localStorage.setItem("user", JSON.stringify(result.id));
      localStorage.setItem("full_name", JSON.stringify(result.full_name));
      localStorage.setItem("username", JSON.stringify(result.username));
      localStorage.setItem("role_id", JSON.stringify(result.role_id));
      sessionStorage.setItem("authToken", JSON.stringify(result.token))
      localStorage.setItem(
        "zreading",
        JSON.stringify(result.is_zcounter ?? "no")
      );
      localStorage.setItem("token", JSON.stringify(result.token));
      localStorage.setItem("config", JSON.stringify(result.permissions));
      toast.success("Successful Login!", { style: toastStyle() });

      setTimeout(() => {
        if (result.role_id === "1" || result.role_id === "4" || result.role_id === "2") {
          navigate("/closedinvoices");
          refreshPage();
        } else if (result.role_id === "3") {
          //if cashier or staff
          navigate("/orderingpage");
          refreshPage();
        } else {
          toast.error("You have no permission to access the system.");
          setTimeout(() => {
            refreshPage();
          }, 1000);
        }
      }, 2000);
    } else if (response.error) {
      toast.error(response.error.data.messages.error, {
        style: toastStyle(),
      });
      setTimeout(function () {
        setDisableClick(false);
      }, 2000);
    }
  }

  async function fetchAllUsers() {
    const response = await UseGetRequest("users/search", {}, buildOwner);
    if (response.data) {
      const res = response.data.map((row) => {
        return {
          value: row.username,
          label: row.username,
        };
      });
      setUserOptions(res);
    } else {
      setUserOptions([]);
    }
  }

  React.useEffect(() => {
    fetchAllUsers();
  }, []);

  return (
    <Row className="login-container p-4">
      <Col 
        className="login-left-side middle"
        xs={24} sm={24} md={24} lg={12} xl={12}
      >
        <img
          src={systemLogo}
          alt={"logo"}
          className="login-logo"
        ></img>
      </Col>
      <Col 
        className="login-right-side p-5" 
        xs={24} sm={24} md={24} lg={12} xl={12}
      >
        <Row>
          <Col span={24} className="login-text" align="center">
              <Space direction="vertical">
                <img
                  src={dreamnestlogo}
                  alt={"logo"}
                  className="login-sub-logo"
                ></img>
                <div>
                  Login to your account
                </div>
              </Space>
          </Col>
        </Row>
        <Row className="mt-3 middle">
          <Col span={12} className="d-flex justify-content-center middle">
            <div className="custom-select-container w-100 middle">
              <UserOutlined className="custom-select-icon" />
              <Select
                suffixIcon={null}
                placeholder="Username"
                options={userOptions}
                showSearch
                filterOption={(input, option) =>
                  option.label?.toLowerCase().includes(input?.toLowerCase())
                }
                onChange={(e) => setUsername(e)}
                autoComplete="off"
                // autoComplete="new-password"
              />
            </div>
          </Col>
        </Row>
        <Row className="d-flex justify-content-center mt-2 center">
          <Col span={12} className="d-flex justify-content-center">
            <Input.Password
              className="login-input"
              prefix={<LockOutlined />}
              type="password"
              placeholder="Password"
              onChange={(e) => setPassword(e.target.value)}
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") && submit(buildOwner)
              }
            />
          </Col>
        </Row>
        <Row>
          <div className="col d-flex justify-content-center mt-3">
            {disableClick === true && (
              <ReactLoading
                type="spinningBubbles"
                color="#2a9d3a"
                height={50}
                width={50}
              />
            )}
            {disableClick === false && (
              <div>
                <Row className="d-flex justify-content-center">
                  <Col span={24} className="d-flex justify-content-center">
                    <Button
                      className="w-100 login-newbtn"
                      onClick={() => submit(buildOwner)}
                    >
                      LOGIN
                    </Button>
                  </Col>
                </Row>
                {/* <Row className="d-flex justify-content-center mt-5">
              <Col xs={6} className="d-flex justify-content-center">
                <Button
                  type="danger"
                  className="exit-button"
                  onClick={() => {
                    localStorage.clear();
                    window.open('/', '_self', '');
                    window.close('/');
                  }}
                >
                  EXIT WINDOW
                </Button>
              </Col>
            </Row> */}
              </div>
            )}
          </div>
        </Row>
    
        <Row>
          <Col span={24} className="login-powered-label mt-5" align="center">
            Powered by EPSOS 1.0.0
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
